export default __webpack_public_path__ + "static/media/minus.77feddb9.svg";